import { Link } from "react-router-dom";

export default function SEButton({ children, variant = 'primary', className = '', ...props }) {
	const baseClasses = `
		relative overflow-hidden group cursor-pointer
		flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium
		focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2
		disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0
		h-10 py-2 md:flex px-6 transition-all duration-500 ease-in-out
	`?.trim();

	const variantClasses = {
		primary: 'text-white bg-gradient-to-r from-blue-600 to-teal-600 focus-visible:ring-blue-500',
		secondary: 'text-white bg-gradient-to-r from-gray-600 to-gray-400 focus-visible:ring-gray-500',
		outline: 'text-blue-600 bg-transparent border border-blue-600 hover:bg-blue-50 focus-visible:ring-blue-500',
		white: 'text-slate-800 bg-gradient-to-r from-slate-100 to-slate-50 hover:bg-slate-200 focus-visible:ring-slate-300',
	};

	// Overlay gradient for hover effect per variant
	const overlayClasses = {
		primary: `absolute inset-0 bg-gradient-to-r from-blue-700 via-teal-700 to-yellow-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out rounded-md pointer-events-none`,
		secondary: `absolute inset-0 bg-gradient-to-r from-gray-700 via-gray-600 to-gray-500 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out rounded-md pointer-events-none`,
		outline: `absolute inset-0 bg-blue-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out rounded-md pointer-events-none`,
		white: `absolute inset-0 bg-gradient-to-r from-slate-300 to-slate-100 opacity-0 group-hover:opacity-100 transition-opacity duration-500 ease-in-out rounded-md pointer-events-none`,
	};

	// Determine selected styles or fallback to primary
	const selectedVariant = variantClasses[variant] ? variant : 'primary';

	return props.to
		? <Link {...props} className={`${baseClasses} ${variantClasses[selectedVariant]} ${className}`}>
			{/* Hover overlay */}
			<span className={overlayClasses[selectedVariant]} />

			{/* Button content */}
			<span className="relative flex items-center justify-center gap-2 pointer-events-none">
				{children}
			</span>
		</Link>
		: <button
			{...props}
			className={`${baseClasses} ${variantClasses[selectedVariant]} ${className}`}
		>
			{/* Hover overlay */}
			<span className={overlayClasses[selectedVariant]} />

			{/* Button content */}
			<span className="relative flex items-center justify-center gap-2 pointer-events-none">
				{children}
			</span>
		</button>
}
